export const SERVER_URL = window.location.href.includes("localhost")
  ? "http://localhost:5000/v1"
  : window.location.href.includes("prod")
    ? "https://design-league-prod-835f54e8a662.herokuapp.com/v1"
    : "https://design-league-344e7b914450.herokuapp.com/v1";

export const SOCKET_URL = window.location.href.includes("localhost")
  ? "http://localhost:5000"
  : window.location.href.includes("prod")
    ? "https://design-league-prod-835f54e8a662.herokuapp.com"
    : "https://design-league-344e7b914450.herokuapp.com/";

export const DEFAULT_MONGO_CONNECTION_NAME = "-org";
export const GOOGLE_CLIENT_ID =
  "785696029297-uf6a2h1f4u60a1nn4gq4699gstofu4c7.apps.googleusercontent.com";
// "316476612623-7gcv2gb7q9h7tgmcsfjasglcsmo5vqfb.apps.googleusercontent.com";

//export const SERVER_URL = "https://design-league-344e7b914450.herokuapp.com/v1";
export const status = {
  APPROVED: "Approved",
  PENDING: "Pending",
  DISAPPROVED: "Disapproved",
  REVISED: "Revised",
};

export const carriers = [
  { value: "FedEx", label: "FedEx" },
  { value: "DHL", label: "DHL" },
];
export const transactionType = {
  RETAINER: "Retainer",
  DEPOSIT: "Deposit",
  CLIENT_CREDIT: "Client Credit",
  REFUND: "Refund",
  VENDOR_CREDIT: "Vendor Credit",
  VENDOR_REFUND: "Vendor Refund",
  OTHER: "Other",
};

export const teamRoles = [
  {
    value: "user",
    label: "Team Member",
  },
  {
    value: "project_manager",
    label: "Project Manager",
  },
  {
    value: "admin",
    label: "Admin",
  },
];

export const teamStatus = [
  {
    value: "true",
    label: "Active",
  },
  {
    value: "false",
    label: "Inactive",
  },
];

// --------- Sales Category  --------
export const salesCategory = [
  { value: "retail", label: "Retail" },
  { value: "wholesale", label: "Wholesale" },
  { value: "direct", label: "Direct" },
  { value: "online_sales", label: "Online Sales" },
  { value: "auction", label: "Auction" },
  { value: "consignment", label: "Consignment" },
];
export const discounts = [
  { value: "no_discount", label: "No Discount" },
  { value: "seasonal_discount", label: "Seasonal Discount" },
  { value: "clearance_sale", label: "Clearance Sale" },
  { value: "bulk_purchase_discount", label: "Bulk Purchse Discount" },
  { value: "member_discount", label: "Member Discount" },
];

// -------- Product Category --------
export const category = [
  {
    value: "furniture",
    label: "Furniture",
    subcategories: [
      { value: "sofas", label: "Sofas" },
      { value: "chairs", label: "Chairs" },
      { value: "tables", label: "Tables" },
      { value: "beds", label: "Beds" },
      { value: "cabinets", label: "Cabinets" },
      { value: "shelves", label: "Shelves" },
    ],
  },
  {
    value: "lighting",
    label: "Lighting",
    subcategories: [
      { value: "celings", label: "Ceiling Lights" },
      { value: "wall_lights", label: "Wall Lights" },
      { value: "table_lamps", label: "Table Lamps" },
      { value: "floor_lamps", label: "Floor Lamps" },
    ],
  },
  {
    value: "decor",
    label: "Wall Decor",
    subcategories: [
      { value: "paintings", label: "Paintings" },
      { value: "wall_art", label: "Wall Art" },
      { value: "mirrors", label: "Mirrors" },
      { value: "clocks", label: "Clocks" },
      { value: "shelves", label: "Shelves" },
    ],
  },
  {
    value: "textiles",
    label: "Textiles",
    subcategories: [
      { value: "curtains", label: "Curtains" },
      { value: "cushions", label: "Cushions" },
      { value: "upholstery", label: "Upholstery" },
      { value: "bedding", label: "Bedding" },
    ],
  },
  {
    value: "flooring",
    label: "Flooring",
    subcategories: [
      { value: "hardwood", label: "Hardwood" },
      { value: "laminate", label: "Laminate" },
      { value: "tile", label: "Tile" },
      { value: "carpet", label: "Carpet" },
      { value: "vinly", label: "Vinly" },
    ],
  },
  {
    value: "accessories",
    label: "Accessories",
    subcategories: [
      { value: "rugs", label: "Rug" },
      { value: "curtains", label: "Curtains" },
      { value: "cushions", label: "Cushions" },
      { value: "vases", label: "Vases" },
      { value: "plants", label: "Plants" },
    ],
  },
];

// -------- Specifications ---------
export const colors = [
  { value: "white", label: "White" },
  { value: "black", label: "Black" },
  { value: "gray", label: "Gray" },
  { value: "red", label: "Red" },
  { value: "blue", label: "Blue" },
  { value: "brown", label: "Brown" },
  { value: "custom", label: "Custom" },
];

export const manufacturer = [
  { value: "ashley_furniture", label: "Ashley Furniture" },
  { value: "ikea", label: "IKEA" },
  { value: "williams_sonoma", label: "Williams-Sonoma" },
  { value: "la-z-boy", label: "La-Z-Boy" },
  { value: "herman_miller", label: "Herman Miller" },
  { value: "steelcase", label: "Steelcase" },
];

export const AVAILABILITY = [
  { value: "in-stock", label: "In Stock" },
  { value: "out-of-stock", label: "Out Of Stock" },
  { value: "pre-order", label: "Pre Order" },
  { value: "discontinued", label: "Discontinued" },
];

export const Materials = [
  { value: "wood", label: "Wood" },
  { value: "plastic", label: "Plastic" },
  { value: "metal", label: "Metal" },
  { value: "leather", label: "Leather" },
  { value: "fabric", label: "Fabric" },
  { value: "glass", label: "Glass" },
];

export const dimensionUnits = [
  { value: "inches", label: "in" },
  { value: "centimeters", label: "cm" },
  { value: "meters", label: "m" },
  { value: "feet", label: "ft" },
  { value: "yards", label: "yd" },
  { value: "millimeters", label: "mm" },
];

export const dimensionUnitMap = {
  inches: "in",
  centimeters: "cm",
  meters: "m",
  feet: "ft",
  yards: "yd",
  millimeters: "mm",
  "": "in",
};
// -------- Pricing --------
export const UnitValues = {
  "%": "%",
  USD: "$",
  EUR: "€",
  AUD: "AU$",
  GBP: "£",
  JPY: "¥",
  CNY: "¥",
  INR: "₹",
  CAD: "CA$",
  CHF: "CHF",
  curr: "$",
  "": "",
};

export const UnitDropDown = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "GBP", value: "GBP" },
  { label: "JPY", value: "JPY" },
  { label: "CNY", value: "CNY" },
  { label: "INR", value: "INR" },
  { label: "AUD", value: "AUD" },
  { label: "CAD", value: "CAD" },
  { label: "CHF", value: "CHF" },
];

export const UnitQuantityType = [
  { label: "Per Item", value: "per_item" },
  { label: "Per Square Foot", value: "per_square_foot" },
  { label: "Per Square Meter", value: "per_square_meter" },
  { label: "Per Yard", value: "per_yard" },
  { label: "Per Meter", value: "per_meter" },
  { label: "Per Pack", value: "per_pack" },
  { label: "Per Dozen", value: "per_dozen" },
];

export const MarkupType = [
  { label: "Fixed Amount", value: "fixed_amount" },
  { label: "Percentage", value: "percentage" },
];

// ------- Tracking --------
export const Carrier = [
  { label: "FedEx", value: "fedex" },
  { label: "UPS", value: "ups" },
  { label: "DHL", value: "dhl" },
  { label: "USPS", value: "usps" },
  { label: "TNT", value: "tnt" },
  { label: "Canada Post", value: "canada_post" },
  { label: "Royal Mail", value: "royal_mail" },
  { label: "China Post", value: "china_post" },
  { label: "Japan Post", value: "japan_post" },
];

export const ShipmentType = [
  { label: "Standard Shipping", value: "stndrd_shipping" },
  { label: "Expedited Shipping", value: "expedited_shipping" },
  { label: "Onernight Shipping", value: "overnight_shipping" },
  { label: "Two-day Shipping", value: "two_day_shipping" },
  { label: "Freight Shipping", value: "freight_shipping" },
  { label: "International Shipping", value: "international_shipping" },
  { label: "Same-day Delivery", value: "same_day_delivery" },
  { label: "In-store Pickup", value: "in_store_pickup" },
];

export const EstLeadTime = [
  { label: "1-3 Days", value: "1_3_days" },
  { label: "3-5 Days", value: "3_5_days" },
  { label: "5-7 Days", value: "5_7_days" },
  { label: "1-2 Weeks", value: "1_2_weeks" },
  { label: "2-3 Weeks", value: "2_3_weeks" },
  { label: "3-4 Weeks", value: "3_4_weeks" },
  { label: "1-2 Months", value: "1_2_months" },
  { label: "2-3 Months", value: "2_3_months" },
  { label: "3+ Months", value: "3_months" },
];
// ------- Project List -------

export const BankPayment = [
  { label: "Bank of America", value: "bank_of_america" },
  { label: "Chase", value: "chase" },
  { label: "Wells Fargo", value: "wells_fargo" },
  { label: "Citibank", value: "citibank" },
  { label: "HSBC", value: "hsbc" },
  { label: "Barclays", value: "barclays" },
  { label: "Deutsche Bank", value: "deutsche_bank" },
  { label: "Standard Chartered", value: "stnd_chartered" },
  { label: "BNP Paribas", value: "bnp_paribas" },
  { label: "Others", value: "other" },
];

export const CreditCardPayment = [
  { label: "Visa", value: "visa" },
  { label: "MasterCard", value: "mastercard" },
  { label: "American Express", value: "american express" },
  { label: "Discover", value: "discover" },
  { label: "Diners Club", value: "diners club" },
  { label: "JCB", value: "jcb" },
  { label: "Union Pay", value: "union pay" },
];

export const ProjectLocation = [
  { label: "Living Room", value: "living room" },
  { label: "Kitchen", value: "kitchen" },
  { label: "Bedroom", value: "bedroom" },
  { label: "Bathroom", value: "bathroom" },
  { label: "Dining Room", value: "dining room" },
  { label: "Home Office", value: "home office" },
  { label: "Basement", value: "basement" },
  { label: "Attic", value: "attic" },
  { label: "Garage", value: "garage" },
  { label: "Patio", value: "patio" },
  { label: "Garden", value: "garden" },
  { label: "Balcony", value: "balcony" },
  { label: "Hallway", value: "hallway" },
  { label: "Laundry Room", value: "laundry room" },
  { label: "EntryWay", value: "entry way" },
  { label: "Nursery", value: "nursery" },
  { label: "Guest Room", value: "guest room" },
  { label: "Family Room", value: "family room" },
  { label: "Study", value: "study" },
  { label: "Walk-in-closet", value: "walk in closet" },
];
export const ProjectStatus = [
  // { label: "Draft", value: "Draft" },
  // { label: "In Progress", value: "In Progress" },
  // { label: "Completed", value: "Completed" },
  // { label: "On Hold", value: "On Hold" },
  // { label: "Cancelled", value: "Cancelled" },
  { label: "Active", value: "Active" },
  { label: "Archive", value: "Archived" },
  { label: "Done", value: "Done" },
];
export const invoiceStatus = [
  { label: "Draft", value: "Draft" },
  { label: "Sent", value: "Sent" },
  { label: "Paid", value: "Paid" },
  { label: "Partially Paid", value: "Partially Paid" },
  { label: "Approved", value: "Approved" },
  { label: "Issued", value: "Issued" },
  { label: "Void", value: "Void" },
];

export const purchaseOrderStatus = [
  { label: "Draft", value: "Draft" },
  { label: "Ordered", value: "Ordered" },
  { label: "Enroute", value: "Enroute" },
  { label: "Delivered", value: "Delivered" },
  { label: "Canceled", value: "Canceled" },
];

export const proposalStatus = [
  { value: "Draft", label: "Draft" },
  { value: "Sent", label: "Sent" },
  { value: "Approved", label: "Approved" },
  { value: "Invoiced", label: "Invoiced" },
  { value: "Paid", label: "Paid" },
  { value: "Partially Paid", label: "Partially Paid" },
];

export const depositStatusValue = {
  Paid: "Paid",
  UPCOMING: "UPCOMING",
  Overdue: "Overdue",
};

export const proposalStatusValue = {
  DRAFT: "Draft",
  SENT: "Sent",
  APPROVED: "Approved",
  INVOICED: "Invoiced",
  PAID: "Paid",
  PARTIAL: "Partially Paid",
};

export const invoiceStatusValue = {
  DRAFT: "Draft",
  SENT: "Sent",
  ISSUED: "Issued",
  VOID: "Void",
  PAID: "Paid",
  PARTIAL: "Partially Paid",
  REFUNDED: "Refunded",
  CREDITED: "Credited",
};

export const purchaseOrderStatusValue = {
  DRAFT: "Draft",
  ORDERED: "Ordered",
  ENROUTE: "Enroute",
  DELIVERED: "Delivered",
  CANCELED: "Canceled",
};

export const quickBooksStatusValue = {
  COMPLETED: "Sync Completed",
  NOT_READY: "Not Ready for Sync",
  NOT_SYNC: "Not Synced",
};
// ------- Services -------

export const serviceSalesCategory = [
  { label: "Design Consultation", value: "design_consultation" },
  { label: "Project Management", value: "projecct_management" },
  { label: "Custom Furniture", value: "custom_furniture" },
  { label: "Renovation Services", value: "renovation_services" },
  { label: "Home Staging", value: "home_staging" },
  { label: "Space Planning", value: "space_planning" },
  { label: "Lighting Design", value: "lighting_design" },
  { label: "Color Consultation", value: "color_consultation" },
  { label: "Material Sourcing", value: "material_sourcing" },
  { label: "Installation Services", value: "installation_services" },
];
export const serviceCatergory = [
  { label: "Residential Design", value: "residential_design" },
  { label: "Commercial Design", value: "commercial_design" },
  { label: "Kitchen Design", value: "kitchen_design" },
  { label: "Bathroom Design", value: "bathroom_design" },
  { label: "Living Room Design", value: "living_room_design" },
  { label: "Bedroom Design", value: "bedroom_design" },
  { label: "Office Design", value: "office_design" },
  { label: "Retail Design", value: "retail_design" },
  { label: "Hospitality Design", value: "hospitality_design" },
  { label: "Outdoor Design", value: "outdoor_design" },
];
export const serviceAvailability = [
  { label: "Available", value: "available" },
  { label: "Not Available", value: "not_available" },
  { label: "Coming Soon", value: "coming_soon" },
  { label: "Seasonal", value: "seasonal" },
];
export const EstServiceTimeFrame = [
  { label: "1-3 Days", value: "1_3_days" },
  { label: "3-5 Days", value: "3_5_days" },
  { label: "1 Week", value: "1_weeks" },
  { label: "2 Weeks", value: "2_weeks" },
  { label: "1 Month", value: "1_months" },
  { label: "2 Months", value: "2_months" },
  { label: "3 Months", value: "3_months" },
  { label: "3+ Months", value: "3_more_months" },
];
export const serviceQuantityType = [
  { label: "Per Hour", value: "per_item" },
  { label: "Per Hour", value: "per_item" },
  { label: "Per Project", value: "per_project" },
  { label: "Per Square Foot", value: "per_square_foot" },
  { label: "Per Square Meter", value: "per_square_meter" },
  { label: "Per Room", value: "per_room" },
  { label: "Per Visit", value: "per_visit" },
  { label: "Per Consultation", value: "per_consultation" },
  { label: "Per Month", value: "per_month" },
  { label: "Per Year", value: "per_year" },
];
export const predefinedUserPermissions = [
  {
    name: "Account Settings",
    extendedFeatures: [
      {
        name: "Tax Categories",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Sales Categories",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
  {
    name: "Projects",
    extendedFeatures: [
      {
        name: "Project Settings",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Specifications",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Locations",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Proposals",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Invoices",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Purchase Orders",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
      // {
      //   name: "Credits & Retainers",
      //   permissions: {
      //     read: false,
      //     write: false,
      //     update: false,
      //     delete: false,
      //   },
      // },
      {
        name: "Tasks",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Order Tracking",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
      // {
      //   name: "Project settings",
      //   permissions: {
      //     read: false,
      //     write: false,
      //     update: false,
      //     delete: false,
      //   },
      // },
    ],
  },
  {
    name: "Design Library",
    extendedFeatures: [
      {
        name: "Manage Specifications",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Add to Projects",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
    ],
  },
  {
    name: "Manage",
    extendedFeatures: [
      {
        name: "Team",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Client",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Vendor",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
  {
    name: "Timesheet",
    extendedFeatures: [
      {
        name: "Approval",
        permissions: {
          read: true,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
];
export const predefinedPermissions = [
  {
    name: "Account Settings",
    extendedFeatures: [
      {
        name: "Tax Categories",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Sales Categories",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
  {
    name: "Projects",
    extendedFeatures: [
      {
        name: "Project Settings",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Specifications",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Locations",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Proposals",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Invoices",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Purchase Orders",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      // {
      //   name: "Credits & Retainers",
      //   permissions: {
      //     read: false,
      //     write: false,
      //     update: false,
      //     delete: false,
      //   },
      // },
      {
        name: "Tasks",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Order Tracking",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
  {
    name: "Design Library",
    extendedFeatures: [
      {
        name: "Manage Specifications",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Add to Projects",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
  {
    name: "Manage",
    extendedFeatures: [
      {
        name: "Team",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Client",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
      {
        name: "Vendor",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
  {
    name: "Timesheet",
    extendedFeatures: [
      {
        name: "Approval",
        permissions: {
          read: false,
          write: false,
          update: false,
          delete: false,
        },
      },
    ],
  },
];
export const predefinedPMPermissions = [
  {
    name: "Account Settings",
    extendedFeatures: [
      {
        name: "Tax Categories",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Sales Categories",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
    ],
  },
  {
    name: "Projects",
    extendedFeatures: [
      {
        name: "Project Settings",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Specifications",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Locations",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Proposals",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Invoices",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Purchase Orders",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      // {
      //   name: "Credits & Retainers",
      //   permissions: {
      //     read: true,
      //     write: true,
      //     update: true,
      //     delete: true,
      //   },
      // },
      {
        name: "Tasks",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Order Tracking",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
    ],
  },
  {
    name: "Design Library",
    extendedFeatures: [
      {
        name: "Manage Specifications",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Add to Projects",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
    ],
  },
  {
    name: "Manage",
    extendedFeatures: [
      {
        name: "Team",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Client",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
      {
        name: "Vendor",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
    ],
  },
  {
    name: "Timesheet",
    extendedFeatures: [
      {
        name: "Approval",
        permissions: {
          read: true,
          write: true,
          update: true,
          delete: true,
        },
      },
    ],
  },
];

export const voidInvoiceOptions = [
  { value: "duplicate_invoice", label: "Duplicate Invoice" },
  { value: "incorrect_amount", label: "Incorrect Amount" },
  {
    value: "customer_requested_cancellation",
    label: "Customer Requested Cancellation",
  },
  { value: "service_not_provided", label: "Service Not Provided" },
  { value: "billing_error", label: "Billing Error" },
  { value: "payment_already_made", label: "Payment Already Made" },
  { value: "invoice_issued_in_error", label: "Invoice Issued in Error" },
  { value: "customer_dispute", label: "Customer Dispute" },
  {
    value: "incorrect_customer_information",
    label: "Incorrect Customer Information",
  },
  { value: "other", label: "Other (Specify Reason)" },
];

export const taxCategories = [
  { value: "product_sales_tax", label: "Products" },
  { value: "shipping_sales_tax", label: "Shipping" },
  { value: "service_sales_tax", label: "Services" },
];

export const taxCalculationRule = [
  { value: "Per Unit", label: "Per Unit" },
  { value: "Per Total", label: "Per Total" },
  { value: "Per Invoice", label: "Per Invoice" },
];

export const taxLimitations = [
  { value: "Below", label: "Below" },
  { value: "Above", label: "Above" },
];

export const searchTaxCategories = [
  { value: "Products", label: "Product Sales Tax" },
  { value: "Shipping", label: "Shipping Sales Tax" },
  { value: "Services", label: "Service Sales Tax" },
];

export const exemptTaxID = {
  "Product Sales Tax": "66f408b4bcd52853e049c6f7",
  "Shipping Sales Tax": "66f4153d8f43c2827baaad80",
  "Service Sales Tax": "66f5239bbcaaaaca70081807",
};

export const billingSubscriptionReasons = [
  { label: "No longer need it", value: "No longer need it" },
  {
    label: "Not seeing the results I wanted",
    value: "Not seeing the results I wanted",
  },
  { label: "Financial Reasons", value: "Financial Reasons" },
  { label: "Others", value: "Others" },
];

// export const taskStatus = [
//   { label: "NOT STARTED", value: "NOT_STARTED" },
//   { label: "IN PROGRESS", value: "IN_PROGRESS" },
//   { label: "COMPLETED", value: "COMPLETED" },
// ];

export const clientTags = [
  { label: "Residential Client", value: "Residential Client" },
  {
    label: "Commercial Client",
    value: "Commercial Client",
  },
  { label: "Developer", value: "Developer" },
  { label: "Real Estate Professional", value: "Real Estate Professional" },
];

export const taskStatus = {
  DRAFT: "draft",
  OPEN: "open",
  DONE: "done",
  OVERDUE: "overdue",
};

export const plansPrices = {
  year: {
    "10+": 30.72,
    "5+": 34.56,
    "1+": 38.4,
  },
  month: {
    "10+": 38.4,
    "5+": 43.2,
    "1+": 48,
  },
};

export const mobileViewLinks = [
  "vendors",
  "clients",
  "createclient",
  "createvendor",
  "login",
  "timesheet",
  "approval",
];
